import { useEffect } from 'react';
import { createLogger } from '@ctrl-enter/tools/utils';
import { useIncrementClickCount } from '../stores/feedback-store';

const logger = createLogger('web:hook:use-click-tracker');

/**
 * Global click tracker hook
 * Attaches a global click event listener to track user engagement
 * Increments click count in feedback store on every click
 *
 * Usage: Call once at app root level (main.tsx or App.tsx)
 */
export const useClickTracker = () => {
  const incrementClickCount = useIncrementClickCount();

  useEffect(() => {
    const handleClick = () => {
      logger.info('👆 [CLICK-TRACKER] Click detected');
      incrementClickCount();
    };

    logger.info('🎯 [CLICK-TRACKER] Click tracker initialized');
    // Attach listener to document (captures all clicks)
    document.addEventListener('click', handleClick);

    // Cleanup on unmount
    return () => {
      logger.info('🔌 [CLICK-TRACKER] Click tracker removed');
      document.removeEventListener('click', handleClick);
    };
  }, [incrementClickCount]);
};
